<tun-music-channel-detail-content-view
  class="wrapper"
>

</tun-music-channel-detail-content-view>
